import LegalLayout, { Section } from "@/components/jobbkarta/LegalLayout";
import { CONTACT_EMAIL } from "@/components/jobbkarta/Footer";
import { Mail } from "lucide-react";

export default function Contact() {
  return (
    <LegalLayout title="Kontakt" testid="page-contact">
      <p>
        Har du en fråga, feedback eller behöver du hjälp med ett köp? Vi svarar så
        snart vi kan.
      </p>

      <Section heading="Mejla oss">
        <a
          href={`mailto:${CONTACT_EMAIL}`}
          data-testid="contact-email"
          className="inline-flex items-center gap-2 rounded-2xl border border-emerald-300 bg-emerald-50 px-5 py-4 text-base font-semibold text-emerald-800 transition-colors hover:bg-emerald-100"
        >
          <Mail className="h-5 w-5" /> {CONTACT_EMAIL}
        </a>
      </Section>

      <Section heading="Frågor om ett köp">
        <p>
          Om din fråga gäller ett köp av Uppföljningsguiden, ange gärna din
          e-postadress och tidpunkt för köpet så hittar vi din order snabbare. Läs
          även våra{" "}
          <a className="font-medium text-emerald-700 hover:underline" href="/kopvillkor">
            köpvillkor
          </a>
          .
        </p>
      </Section>
    </LegalLayout>
  );
}
